import {
    postUpsellUserSelection,
    fetchTranckingDataFromLegacy,
    postPaymentMethodSelection
} from '@/api/legacyAPI';

export const AnalyticsService = () => {
    const saveUpsellUserSelection = async (fid, data) => {
        return await postUpsellUserSelection(fid, data);
    }

    const fetchTrackingData = async (fid) => {
        return await fetchTranckingDataFromLegacy(fid);
    }

    const savePaymentMethodSelection = async (pbId, paymentMethod) => {
        return await postPaymentMethodSelection(pbId, paymentMethod);
    }

    return {
        saveUpsellUserSelection,
        fetchTrackingData,
        savePaymentMethodSelection
    }
}